#@import Booking.Presenters.Base
#@export Booking.Presenters.Book

class Booking.Presenters.Book extends Booking.Presenters.Base

  toHash: ->
    notYet = @model.isDealNotYetOpen()
    bookAndBuy = @model.getBookAndBuy()
    reschedule = @model.getReschedule()
    requestAppointment = @model.isARSE()
    isG3 = @model.isG3()
    schedulingNounCapitalized = @getSchedulingNoun capitalized: true
    isPartialIntent = @model.isPartialIntent()

    showPoweredBy = @model.isBookerDeal() and bookAndBuy
    poweredByImageUrl = @imageUrl('booking-powered-by-booker.png')

    # bookAndBuy is true only on the deal page, only if they're on
    # the deal page we want to let them go through without completing
    # the widget
    if bookAndBuy and !window.mobileHelper
      isDisabled = @model.getIsBooking() is true or not @model.isReadyToBuy()
    else
      isDisabled = @model.getIsBooking() is true or not @model.isReadyToBook()

    {isDisabled, notYet, bookAndBuy, reschedule, requestAppointment, schedulingNounCapitalized, isPartialIntent, showPoweredBy, poweredByImageUrl, isG3}
